import { BarChartOutlined, CalendarOutlined, DashboardOutlined, RobotOutlined, GlobalOutlined, FundOutlined, FundProjectionScreenOutlined, UnorderedListOutlined, FileTextOutlined, TeamOutlined, ProfileOutlined } from '@ant-design/icons';

const dashboard = {
  id: 'group-main',
  title: 'Main',
  type: 'group',
  children: [
    {
      id: 'command-center',
      title: 'Command Center',
      type: 'item',
      url: '/command-center',
      icon: DashboardOutlined,
      breadcrumbs: false
    },
    {
      id: 'activities',
      title: 'Mhesh Activities',
      type: 'item',
      url: '/activities',
      icon: CalendarOutlined,
      breadcrumbs: false
    },
    {
      id: 'voter-intelligence',
      title: 'Voter Intelligence',
      type: 'item',
      url: '/voter-intelligence',
      icon: FundProjectionScreenOutlined,
      breadcrumbs: false
    },
    {
      id: 'voter-register',
      title: 'My Voters',
      type: 'item',
      url: '/voter-register',
      icon: TeamOutlined,
      breadcrumbs: false
    },
    {
      id: 'manifesto',
      title: 'Mhesh Manifesto',
      type: 'item',
      url: '/manifesto',
      icon: FileTextOutlined,
      breadcrumbs: false
    },
    {
      id: 'mhesh-ai-assistant',
      title: 'Mhesh AI Assistant',
      type: 'item',
      url: '/mhesh-ai-assistant',
      icon: RobotOutlined,
      breadcrumbs: false
    },
    {
      id: 'news-intelligence',
      title: 'News Intelligence',
      type: 'item',
      url: '/news-intelligence',
      icon: GlobalOutlined,
      breadcrumbs: false
    },
    {
      id: 'polls-surveys',
      title: 'Polls & Surveys',
      type: 'item',
      url: '/polls-surveys',
      icon: BarChartOutlined,
      breadcrumbs: false
    },
    {
      id: 'poll-results',
      title: 'Polls Reports',
      type: 'item',
      url: '/elections/poll-results',
      icon: FundOutlined,
      breadcrumbs: false
    },
    {
      id: 'reports',
      title: 'Reports',
      type: 'item',
      url: '/reports',
      icon: ProfileOutlined,
      breadcrumbs: false
    }
  ]
};

export default dashboard;
